export enum LocalVideoStatus {
    Disabled = 1,
    Loading = 2,
    Enabled = 3
}
